export default "__VITE_ASSET__DoIl73E7__"